import Echo from 'laravel-echo';
import IMask from 'imask';
import Pusher from 'pusher-js'
import moment from 'moment';

window.Pusher = Pusher;
window.moment = moment;
window.IMask = IMask;

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    wsHost: process.env.MIX_PUSHER_HOST.replace(/((http:\/\/)|(https:\/\/))/g, '').replace(':8000', ''),
    encrypted: process.env.MIX_PUSHER_HOST.includes('https://'),
    wsPort: process.env.MIX_PUSHER_PORT,
    wssPort: process.env.MIX_PUSHER_PORT,
    forceTLS: process.env.MIX_PUSHER_HOST.includes('https://'),
    enabledTransports: ['wss', 'ws']
});

window.Echo.disconnect()

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */

// import './echo';
